module.exports = __webpack_public_path__ + "static/media/reactLogo.8ac4154e.png";